<template>
    <v-ons-page class="pgsetup">
      <v-ons-card>
          <v-ons-list-item tappable modifier="nodivider" class="accordion" @click="toggle($event)">
            <h4>Voice Settings</h4>
          </v-ons-list-item>
          <div class="panel">
            <div tappable class="bundle-info">

              <v-ons-list-header>Forward All Calls</v-ons-list-header>
              <ons-list-item>
                <label class="center">Enable</label>
                <div class="right">
                  <v-ons-switch
                      input-id="switch1"
                      @change="toggleCallForwarding($event)"
                      v-model="forwardAllOn"
                  ></v-ons-switch>
                </div>
              </ons-list-item>
              <ons-list-item v-if="forwardAllOn">
                <label class="center">Destination</label>
                <div class="right">
                  <v-ons-input
                      float
                      type="number"
                      maxlength="6"
                      placeholder="enter number"
                      required="true"
                      v-model="forwardAllNumber"
                      @input="validateLength($event)"
                  ></v-ons-input>
                </div>
              </ons-list-item>
              <v-ons-list-item v-if="forwardAllOn">
                <div class="right">
                  <ons-button
                      @click="updateForwardAllCalls()"
                      ripple
                      modifier="material--flat light cta"
                      style="color:#00C694"
                  >Save</ons-button>
                </div>
              </v-ons-list-item>

              <v-ons-list-header>Forward call: no answer</v-ons-list-header>
              <ons-list-item>
                <label class="center">Enable</label>
                <div class="right">
                  <v-ons-switch
                      input-id="switch2"
                      @change="toggleForwardNoAnswerOn($event)"
                      v-model="forwardNoAnswerOn"
                  ></v-ons-switch>
                </div>
              </ons-list-item>
              <ons-list-item v-if="forwardNoAnswerOn">
                <label class="center">Destination</label>
                <div class="right">
                  <v-ons-input
                      float
                      type="number"
                      maxlength="6"
                      placeholder="enter number"
                      required="true"
                      v-model="forwardNoAnswerNumber"
                      @input="validateLength($event)"
                  ></v-ons-input>
                </div>
              </ons-list-item>
              <v-ons-list-item v-if="forwardNoAnswerOn">
                <div class="right">
                  <ons-button
                      ripple
                      modifier="material--flat light cta"
                      style="color:#00C694"
                      @click="updateForwardOnNoAnswer()"
                  >Save</ons-button>
                </div>
              </v-ons-list-item>

              <v-ons-list-header>Forward call: Busy</v-ons-list-header>
              <ons-list-item>
                <label class="center">Enable</label>
                <div class="right">
                  <v-ons-switch
                      input-id="switch3"
                      @change="toggleForwardBusyOn($event)"
                      v-model="forwardBusyOn"
                  ></v-ons-switch>
                </div>
              </ons-list-item>
              <ons-list-item v-if="forwardBusyOn">
                <label class="center">Destination</label>
                <div class="right">
                  <v-ons-input
                      float
                      type="number"
                      maxlength="6"
                      placeholder="enter number"
                      required="true"
                      v-model="forwardBusyNumber"
                      @input="validateLength($event)"
                  ></v-ons-input>
                </div>
              </ons-list-item>
              <v-ons-list-item v-if="forwardBusyOn">
                <div class="right">
                  <ons-button
                      ripple
                      modifier="material--flat light cta"
                      style="color:#00C694"
                      @click="updateForwardOnBusy()"
                  >Save</ons-button>
                </div>
              </v-ons-list-item>

              <v-ons-list-header>Do Not Disturb</v-ons-list-header>
              <v-ons-list-item>
                <label class="center">Enable</label>
                <div class="right">
                  <v-ons-switch
                      input-id="switch4"
                      v-model="dndOn"
                      @change="updateDoNotDisturb($event)"
                  ></v-ons-switch>
                </div>
              </v-ons-list-item>
              <v-ons-list-header>Availability Status</v-ons-list-header>
              <v-ons-list-item>
                <v-ons-select v-model="selectedStatus" style="width: 100%">
                  <option
                      v-for="(item, i) in availabilityStatus"
                      :key="`AS-${i}`"
                      :value="item.value"
                  >{{ item.text }}</option>
                </v-ons-select>
              </v-ons-list-item>
            </div>
          </div>
        </v-ons-card>
      <v-ons-card v-show="isDeveloper">
        <v-ons-list-item tappable modifier="nodivider" class="accordion" @click="toggle($event)">
          <h4>Data Settings</h4>
        </v-ons-list-item>
        <div class="panel">
          <v-ons-row>
            <v-ons-col width="80%">
              <p>Data Notifications</p>
            </v-ons-col>
            <v-ons-col>
              <p>
                <v-ons-switch></v-ons-switch>
              </p>
            </v-ons-col>
          </v-ons-row>
          <v-ons-row>
            <v-ons-col width="80%">
              <p>SMS (+27712345678)</p>
            </v-ons-col>
            <v-ons-col>
              <p class="pull-end">
                <ons-checkbox checked></ons-checkbox>
              </p>
            </v-ons-col>
          </v-ons-row>
          <v-ons-row>
            <v-ons-col width="80%">
              <p>Email (data@gmail.com)</p>
            </v-ons-col>
            <v-ons-col>
              <p class="pull-end">
                <ons-checkbox></ons-checkbox>
              </p>
            </v-ons-col>
          </v-ons-row>
        </div>
      </v-ons-card>
      <v-ons-card v-show="isUserAdmin">
        <v-ons-list-item tappable modifier="nodivider" class="accordion" @click="toggle($event)">
          <h4>Billing Settings</h4>
        </v-ons-list-item>
        <div class="panel">
          <v-ons-row class="credit-card">
            <p>Update your credit card information</p>
            <add-card></add-card>
          </v-ons-row>
        </div>
      </v-ons-card>
      <v-ons-card v-show="isUserAdmin">
        <v-ons-row>
          <default-card></default-card>
        </v-ons-row>
      </v-ons-card>
    </v-ons-page>
</template>

<script>
import bus from "@/bus";
import TopUp from "@/views/TopUp";

export default {
    components: {
      "add-card": () => import("@/components/CardComponent.vue"),
      "default-card": () => import("@/components/DefaultCardComponent.vue")
    },
    data() {
        return {
            forwardBusyOn: false,
            forwardBusyNumber: '',
            forwardNoAnswerOn: false,
            forwardNoAnswerNumber: '',
            forwardAllOn: false,
            forwardAllNumber: '',
            dndOn: false,
            volume: 25,
            isUserAdmin: false,
            isDeveloper: false,
            availabilityStatus: [
                { text: 'Available', value: 'Available' },
                { text: 'Available (On Demand)', value: 'Available (On Demand)' },
                { text: 'Logged Out', value: 'Logged Out' },
                { text: 'On Break', value: 'On Break' },
                { text: 'Do Not Disturb', value: 'Do Not Disturb' },
            ],
            selectedStatus: 'On Break',
        };
    },
    mounted() {
        const _token = this.getlocatStorageToken();
        if (_token) {
            this.getCallForwardingSettings().then(res => {
                /**
                 * {
                 * do_not_disturb
                 * forward_no_answer_enabled
                 * forward_no_answer_destination
                 * forward_busy_enabled
                 * forward_busy_destination
                 * forward_all_enabled
                 * forward_all_destination }
                 */
                const do_not_disturb = res.data.do_not_disturb;
                const no_answer_enabled = res.data.forward_no_answer_enabled;
                const no_answer_destination = res.data.forward_no_answer_destination;
                const busy_enabled = res.data.forward_busy_enabled;
                const busy_destination = res.data.forward_busy_destination;
                const all_enabled = res.data.forward_all_enabled;
                const all_destination = res.data.forward_all_destination;

                if (do_not_disturb && do_not_disturb == 'true') {
                    this.dndOn = true;
                }
                if (no_answer_enabled && no_answer_enabled == 'true') {
                    this.forwardNoAnswerOn = true;
                }
                if (busy_enabled && busy_enabled == 'true') {
                    this.forwardBusyOn = true;
                }
                if (all_enabled && all_enabled == 'true') {
                    this.forwardAllOn = true;
                }

                this.forwardNoAnswerNumber = parseInt(no_answer_destination);
                this.forwardBusyNumber = parseInt(busy_destination);
                this.forwardAllNumber = parseInt(all_destination);
            });
        } else {
            bus.$on(':tokenReceived', () => {
                this.getCallForwardingSettings().then(res => {
                    // this.forwardOn = res.data.enable_forwarding;
                    if (res.data.enable_forwarding == 'false') {
                        this.forwardOn = false;
                    } else {
                        this.forwardOn = true;
                    }
                    this.forwardNumber = parseInt(res.data.forward_destination);
                });
            });
        }
        this.listenForAdminStatus();
    },
    methods: {
        async updateForwardAllCalls() {
            if (this.forwardAllOn && this.forwardAllNumber) {
                this.CallForwarding()
                    .then(res => {
                        if (res.data.success) {
                            this.$ons.notification.toast(res.data.message, { timeout: 2000, animation: 'fall' });
                        } else {
                            this.$ons.notification.toast(res.data.message, { timeout: 2000, animation: 'fall' });
                        }
                    })
                    .catch(err => {
                        this.$ons.notification.toast(err, { timeout: 2000, animation: 'fall' });
                    });
            }
        },
        async CallForwarding() {
            return this.$http.post('/forwardcall/all', {
                forward_all_enabled: this.forwardAllOn,
                forward_all_destination: this.forwardAllNumber,
            });
        },
        async toggleCallForwarding(e) {
            this.forwardAllOn = e.value;
            if (!this.forwardAllOn) {
                const _token = this.getlocatStorageToken();
                this.$http
                    .post('/forwardcall/all', {
                        forward_all_enabled: this.forwardAllOn,
                    })
                    .then(res => {
                        if (res.data.success) {
                            this.$ons.notification.toast(res.data.message, {
                                timeout: 2000,
                                animation: 'fall',
                            });
                        }
                    })
                    .catch(err => {
                        this.$ons.notification.toast(`error ${err}`, { timeout: 2000, animation: 'fall' });
                    });
            }
        },
        toggleForwardNoAnswerOn(e) {
            this.forwardNoAnswerOn = e.value;

            /** user is disabling forwarding */
            if (!this.forwardNoAnswerOn) {
                const _token = this.getlocatStorageToken();
                this.$http
                    .post('/forwardcall/no-answer', {
                        forward_no_answer: this.forwardNoAnswerOn,
                    })
                    .then(res => {
                        if (res.data.success) {
                            this.$ons.notification.toast(res.data.message, {
                                timeout: 2000,
                                animation: 'fall',
                            });
                        }
                    })
                    .catch(err => {
                        this.$ons.notification.toast('Failed to update status!', { timeout: 2000, animation: 'fall' });
                    });
            }
        },
        toggleForwardBusyOn(e) {
            this.forwardBusyOn = e.value;
            if (!this.forwardBusyOn) {
                const _token = this.getlocatStorageToken();
                this.$http
                    .post('/forwardcall/user-busy', {
                        forward_busy: this.forwardBusyOn,
                    })
                    .then(res => {
                        if (res.data.success) {
                            this.$ons.notification.toast(res.data.message, {
                                timeout: 2000,
                                animation: 'fall',
                            });
                        }
                    })
                    .catch(err => {
                        this.$ons.notification.toast('Failed to update status!', { timeout: 2000, animation: 'fall' });
                    });
            }
        },
        updateDoNotDisturb(e) {
            this.$http
                .post('/donotdisturb', { do_not_disturb: e.value })
                .then(res => {
                    if (res.data.success) {
                        this.$ons.notification.toast(res.data.message, {
                            timeout: 2000,
                            animation: 'fall',
                        });
                    }
                })
                .catch(err => {
                    this.$ons.notification.toast('Failed to update status!', { timeout: 2000, animation: 'fall' });
                });
        },
        updateForwardOnBusy() {
            if (this.forwardBusyOn && this.forwardBusyNumber) {
                this.$http
                    .post('/forwardcall/user-busy', {
                        forward_busy: this.forwardBusyOn,
                        forward_busy_destination: this.forwardBusyNumber,
                    })
                    .then(res => {
                        if (res.data.success) {
                            this.$ons.notification.toast(res.data.message, {
                                timeout: 2000,
                                animation: 'fall',
                            });
                        }
                    });
            }
        },
        updateForwardOnNoAnswer() {
            if (this.forwardNoAnswerOn && this.forwardNoAnswerNumber) {
                this.$http
                    .post('/forwardcall/no-answer', {
                        forward_no_answer: this.forwardNoAnswerOn,
                        forward_no_answer_destination: this.forwardNoAnswerNumber,
                    })
                    .then(res => {
                        if (res.data.success) {
                            this.$ons.notification.toast(res.data.message, {
                                timeout: 2000,
                                animation: 'fall',
                            });
                        }
                    });
            }
        },
        getCallForwardingSettings() {
            return this.$http.get('/forwardcall');
        },
        getlocatStorageToken() {
            const _token = localStorage.getItem('app:ACCESS_TOKEN');
            if (!_token) {
                return;
            }
            return _token;
        },
        validateLength(value) {
            if (this.forwardAllNumber.toString().length > 12) {
                this.forwardAllNumber = this.forwardAllNumber.toString().slice(0, 12);
            }
        },
        toggle(el) {
          el.target.classList.toggle("active");
          el.target.nextElementSibling.classList.toggle("show");
        },
      listenForAdminStatus() {
        bus.$on("::ISADMIN", (status) => {
          this.isUserAdmin = status;
        });
        bus.$on("::ISDEVELOPER", (status) => {
          this.isDeveloper = status;
        });
      }
    },
};
</script>

<style scoped lang="scss">
.accordion {
  transition: 0.4s;
  padding-left: 0;
}
.accordion:before {
  margin-top: 3px;
  padding-left: 5px;
  padding-right: 5px;
  content: '\02795';
}

.accordion.active:before {
  content: "\2796";
}

div.panel {
  max-height: 0;
  overflow: hidden;
  transition: 0.6s ease-in-out;
  opacity: 0;
}

div.panel.show {
  opacity: 1;
  max-height: 500px;
}
.credit-card {
  display: block;
  p {
    text-align: center;
  }
}
.pgsetup {
    label, .list-item, .list-item__center{
        font-family: 'Poppins',sans-serif !important;
        font-size: 14px;
    }
}
.right-icon {
    margin-left: 10px;
}
.right-label {
    color: #666;
}
.settings-text {
    margin-bottom: 25px;
    text-align: center;
}
</style>
